module.exports = __webpack_public_path__ + "static/media/img-myrank.c6f52781.png";